import { Button } from '@xprog/prensa'
import React from 'react'

export const NewsletterButton: React.FC<any> = props => {
  return (
    <Button
      {...props}
      variant='filled'
      css={{
        button: {
          background: '#164194',
          borderRadius: '$unset',
          height: '40px',
          width: '100%',
          '@lg': {
            width: '120px'
          }
        },
        label: {
          color: '$basicWhite',
          fontFamily: '$primary',
          fontSize: '18px',
          fontWeight: '700',
        }
      }}
    >
      Enviar
    </Button>
  )
}